import React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import { useLocation } from "@reach/router";
import { useStaticQuery, graphql } from "gatsby";

const SEO = ({ title, description, image }) => {
  const { pathname } = useLocation();
  const { site, coverPhoto } = useStaticQuery(query);
  const defaultMetadata = site.siteMetadata;
  const defaultTitle = defaultMetadata.title;
  const defaultDescription = defaultMetadata.description;
  const siteUrl = defaultMetadata.siteUrl;
  const seoImage = image ?? (coverPhoto?.childImageSharp?.gatsbyImageData);

  const seo = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    image: `${siteUrl}${seoImage.images.fallback.src}`,
    url: `${siteUrl}${pathname}`,
  };
  return (
    <Helmet title={seo.title}>
      <meta name="description" content={seo.description} />
      <meta name="image" content={seo.image} />
      {/** Open Graph / facebook */}
      <meta property="og:type" content="website"/>
      {seo.url && <meta property="og:url" content={seo.url} />}
      {/* {(article ? true : null) && <meta property="og:type" content="article" />} */}
      {seo.title && <meta property="og:title" content={seo.title} />}
      {/* {seo.description && (
        <meta property="og:description" content={seo.description} />
      )} */}
      {seo.image && <meta property="og:image" content={seo.image} />}

      {/** Twitter */} 
      <meta name="twitter:card" content="summary_large_image" />
      {seo.url && <meta property="twitter:url" content={seo.url} />}
      {/* {twitterUsername && (
        <meta name="twitter:creator" content={twitterUsername} />
      )} */}
      {seo.title && <meta name="twitter:title" content={seo.title} />}
      {/* {seo.description && (
        <meta name="twitter:description" content={seo.description} />
      )} */}
      {seo.image && <meta name="twitter:image" content={seo.image} />}
    </Helmet>
  );
};
export default SEO;

SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  siteUrl: PropTypes.string,
};

SEO.defaultProps = {
  title: null,
  description: null,
  image: null,
};

const query = graphql`
  query SEO {
    site {
      siteMetadata {
        description
        siteUrl
        title
      }
    }
    coverPhoto: file(absolutePath: { glob: "**/src/media/cover_photo.png" }) {
      childImageSharp {
        gatsbyImageData(layout: FIXED, width: 1200)
      }
    }
  }
`;
